module.exports = __webpack_public_path__ + "static/img/bc-wsjtz.65a2627.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/bc-wsjtz.png
// module id = 0wTX
// module chunks = 0